import { Component } from '@angular/core';

@Component({
  selector: 'app-contador_pub',
  standalone: true,
  templateUrl: './contador_pub.component.html',
  styleUrls: ['./contador_pub.component.css'],
})
export class Contador_pubComponent {}